import { Identity } from "@pdfking/tfunc"

import { getter } from "./getter"
import { scan } from "./scan"

/**
 * Removes duplicates from iterable.
 *
 * Uses key function to determine uniqueness. Keeps last occurrence.
 *
 * @param iterable - Array, object, or primitive
 * @param f - Key function or property name (default: Identity)
 * @returns Array with duplicates removed
 *
 * @example
 * ```ts
 * import { delete_duplicates } from "@pdfking/rfunc"
 *
 * delete_duplicates([1, 2, 1, 3]) // [2, 1, 3]
 * delete_duplicates([{ a: 1 }, { a: 1 }, { a: 2 }], "a") // [{ a: 1 }, { a: 2 }]
 * ```
 */
export const delete_duplicates = (iterable, f: any = Identity) => {
  const map = new Map()
  const g = getter(f)

  scan(item => map.set(g(item), item), iterable)

  return [...map.values()]
}
